export const mapsAutocompleteOptions = {
	fields: ['formatted_address', 'name', 'geometry.location'],
}
